import React from 'react';
import Card from '../../Card';
import {Row, Col, Button, Form} from "react-bootstrap";
import cookie from "react-cookies";
import LaserCalibrator from "../../../util/LaserCalibrator";
import {withRouter} from "react-router"
import PostWelcomePage from "./PostLaunchPage";

class CalibrateLaser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            h: 90,
            s: 177.5,
            v: 228,
            hRadius: 70,
            sRadius: 77.5,
            vRadius: 28,
            // startButton: true
        };

        this.canvasRef = React.createRef();

        const config = cookie.load("laserConfig")
        if (!!config) {
            this.state = {...this.state, ...config}
        }
    }

    startCalibrating() {
        this.setState({
            startButton: false
        }, () => {
            const canvas = this.canvasRef.current;
            const video = this.props.videoRef.current;

            this.calibrator = new LaserCalibrator(video, canvas)
            this.calibrator.init();

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            this.updateCalibrator();
        })
    }

    componentDidMount() {
        this.startCalibrating()
    }

    doneCalibrating() {
        const config = {
            h: this.state.h,
            s: this.state.s,
            v: this.state.v,
            hRadius: this.state.hRadius,
            sRadius: this.state.sRadius,
            vRadius: this.state.vRadius
        }
        cookie.save("laserConfig", config)
        this.props.history.push('/launch')
    }

    updateCalibrator() {
        if (!!this.calibrator) {
            this.calibrator.tryLaserCalibration(this.state.h, this.state.s, this.state.v, this.state.hRadius, this.state.sRadius, this.state.vRadius)
        }
    }

    updateValue(object) {
        this.setState(object, () => {
            this.updateCalibrator()
        })
    }

    render() {
        return (
            <PostWelcomePage>
                <Row>
                    <Col sm={12} className={"text-center"}>
                        <h3>레이저 보정</h3>
                        <p>샤프슈터가 사격을 감지하기 전에 레이저를 볼 수 있도록 보정해야 합니다. 아래에 두 개의 피드가 있는데, 왼쪽은 웹캠에서 실시간으로 보이는 화면이고 오른쪽은 테이크 에임의 레이저 감지 화면입니다. 프로젝터 스크린에 레이저를 비추세요. 올바르게 보정되면 샤프슈터는 오른쪽 화면에 작은 흰색 원으로 표시합니다. 원이 보이지 않으면 아래 슬라이더를 보일 때까지 조정하세요.</p>
                        <p>보정을 마치면 아래의 "보정 완료" 버튼을 클릭하세요!</p>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} style={{textAlign: "center"}}>
                        <canvas ref={this.canvasRef} ></canvas>
                    </Col>
                </Row>
                <br />
                <Row style={{paddingBottom: "20px"}}>
                    <Col sm={6}>
                        <Card>
                            <Form.Group>
                                <Form.Label>색상(Hue) (H) - {this.state.h}</Form.Label>
                                <Form.Control type="range" min={0} max={179} value={this.state.h} onChange={(value) => {this.updateValue({h: parseInt(value.target.value)})}}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>채도(Saturation) (S) - {this.state.s}</Form.Label>
                                <Form.Control type="range" min={0} max={255} value={this.state.s} onChange={(value) => {this.updateValue({s: parseInt(value.target.value)})}}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>명도(Value) (V) - {this.state.v}</Form.Label>
                                <Form.Control type="range" min={0} max={255} value={this.state.v} onChange={(value) => {this.updateValue({v: parseInt(value.target.value)})}}/>
                            </Form.Group>
                        </Card>
                    </Col>
                    <Col sm={6}>
                        <Card>
                            <Form.Group>
                                <Form.Label>색상(Hue) 반경 - {this.state.hRadius}</Form.Label>
                                <Form.Control type="range" min={0} max={89} value={this.state.hRadius} onChange={(value) => {this.updateValue({hRadius: parseInt(value.target.value)})}}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>채도(Saturation) 반경 - {this.state.sRadius}</Form.Label>
                                <Form.Control type="range" min={0} max={127} value={this.state.sRadius} onChange={(value) => {this.updateValue({sRadius: parseInt(value.target.value)})}}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>명도(Value) 반경 - {this.state.vRadius}</Form.Label>
                                <Form.Control type="range" min={0} max={127} value={this.state.vRadius} onChange={(value) => {this.updateValue({vRadius: parseInt(value.target.value)})}}/>
                            </Form.Group>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className={"text-center"}>
                        <Button variant="customPrimary" onClick={() => {this.doneCalibrating()}}>보정 완료</Button>
                    </Col>
                </Row>
            </PostWelcomePage>
        );
    }

}

export default withRouter(CalibrateLaser);